import React from 'react'

import html from '../../images/tech/html-5.svg'
import javascript from '../../images/tech/javascript.svg'
import react from '../../images/tech/react.svg'
import python from '../../images/tech/python.svg'
import hadoop from '../../images/tech/apache-hadoop.svg'
import spark from '../../images/tech/spark.svg'
import hive from '../../images/tech/hive.svg'
import postgres from '../../images/tech/postgres.svg'
import java from '../../images/tech/java.svg'
import aws from '../../images/tech/aws.svg'
import flask from '../../images/tech/flask.svg'
import bash from '../../images/tech/bash.svg'

import './skills.scss'

function Skills() {
  return (
    <section className="portfolio__section skills">
      <h2 className="portfolio__header">Skills</h2>
      <h3 className="portfolio__sub-header">Technologies that I use currently</h3>
      <div className="g-3">
      <img className="skills__img" src={java} alt="React.js" title="Java" />
        <img className="skills__img" src={python} alt="Python" title="Python" />
        <img className="skills__img" src={aws} alt="Python" title="Amazon Web Services" />

       
      </div>
      <div className="g-3">
        
          <img className="skills__img" src={spark} alt="Apache Spark" title="Apache Spark" />
          <img className="skills__img" src={hive} alt="Apache Hive" title="Apache Hive" />
          <img className="skills__img" src={hadoop} alt="Apache Hadoop" title="Apache Hadoop" />
      </div>
      <div className="g-3">
      <img className="skills__img" src={react} alt="React.js" title="React.js" />
        <img className="skills__img" src={javascript} alt="Javscript" title="Javscript" />
        <img className="skills__img" src={html} alt="HTML" title="HTML" />       
      </div>
      <div className="g-3">
      <img className="skills__img" src={postgres} alt="PostGres" title="PostGres" />
      <img className="skills__img" src={flask} alt="Flask" title="Flask" />
      <img className="skills__img" src={bash} alt="Bash" title="Bash" />

      </div>

    </section>
  )
}

export default Skills